/**
 * Hand a Blob to the browser as a download.
 *
 * Used for files the SERVER produced (a generated report), as opposed to `gridExport`, which
 * builds a workbook client-side from grid rows. Both end in the same anchor-click, but only one
 * of them has bytes to revoke afterwards — the object URL is released on the next tick, because
 * revoking it synchronously races the download in Safari and the file arrives empty.
 *
 * @param {Blob} blob the bytes
 * @param {string} filename including its extension
 */
export const saveBlob = (blob, filename) => {
	const url = URL.createObjectURL(blob);
	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = filename;
	anchor.style.display = 'none';
	document.body.appendChild(anchor);
	anchor.click();
	document.body.removeChild(anchor);
	setTimeout(() => URL.revokeObjectURL(url), 0);
};

export default saveBlob;
